(function() {
  // Verhindert doppelte Initialisierung
  if (window.storyblokProductAreaInitialized) {
    return;
  }
  window.storyblokProductAreaInitialized = true;

  const MOBILE_BREAKPOINT = 1024;

  // --- SCRIPT 1: ACCORDION (FÜR MOBILE) ---
  const initStoryblokAccordion = () => {
    const sections = document.querySelectorAll('[data-storyblok-scrollspy] .sb-scroll-section');
    if (!sections.length) return;

    sections.forEach(section => {
      // Sicherheits-Check: Wrapper nicht doppelt erstellen
      if (section.querySelector('.sb-accordion-content')) return;

      if (section.dataset.accordionInit) return;
      section.dataset.accordionInit = 'true';

      const title = section.querySelector('.sb-scroll-section-title');
      if (!title) return;

      const contentWrapper = document.createElement('div');
      contentWrapper.classList.add('sb-accordion-content');

      let nextNode = title.nextElementSibling;
      while (nextNode) {
        contentWrapper.appendChild(nextNode);
        nextNode = title.nextElementSibling;
      }
      section.appendChild(contentWrapper);

      title.addEventListener('click', (e) => {
        e.stopPropagation();
        section.classList.toggle('sb-is-open');
        const content = contentWrapper; 

        if (section.classList.contains('sb-is-open')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = '0';
        }
      });
    });
  };

  // --- SCRIPT 2: SCROLLSPY (ORIGINAL-LOGIK IM INTERVAL-MODUS) ---
  const initStoryblokScrollspy = () => {
    // Aufräumen alter Instanzen (Intervalle & Observer)
    if (window['_sbContentObserver']) window['_sbContentObserver'].disconnect();
    if (window['_sbWrapperObserver']) window['_sbWrapperObserver'].disconnect();
    if (window['_sbInterval']) clearInterval(window['_sbInterval']);
    
    // Entferne alten Scroll-Listener, falls vorhanden (um Duplikate zu vermeiden)
    // Da wir anonyme Funktionen nutzen, ist das schwierig, aber durch 
    // das 'window.storyblokProductAreaInitialized' oben verhindern wir das Gröbste.

    const wrapper = document.querySelector('[data-storyblok-scrollspy]');
    if (!wrapper) return;

    const nav = wrapper.querySelector('.sb-scroll-nav');
    const links = wrapper.querySelectorAll('.sb-scroll-link');
    const sections = wrapper.querySelectorAll('.sb-scroll-section');
    const mainHeader = document.querySelector('store-header') || document.querySelector('header');
    const body = document.body;
    const root = document.documentElement;
    const debugOutput = document.getElementById('sb-debug-output');

    if (links.length === 0 || sections.length === 0 || !mainHeader) {
      console.warn('Storyblok Scrollspy: Wichtige Elemente nicht gefunden.');
      return;
    }

    let lastKnownTotalHeight = -2;

    // 1. Sticky State Observer (Wann wird die Leiste fest?)
    const wrapperNavHeight = nav.offsetHeight;
    const wrapperHeaderHeight = mainHeader.offsetHeight;
    
    window['_sbWrapperObserver'] = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        body.classList.add('scrollspy-is-active');
      } else {
        body.classList.remove('scrollspy-is-active');
      }
    }, { 
      root: null,
      rootMargin: `-${wrapperHeaderHeight + wrapperNavHeight}px 0px -40% 0px`,
      threshold: 0
    });
    window['_sbWrapperObserver'].observe(wrapper);


    // 2. Die Update-Funktion (Deine Original-Logik)
    const updatePositions = () => {
      const mainHeaderHeight = mainHeader.offsetHeight;
      
      // Hier berechnen wir die Position dynamisch
      // Wenn der Header beim Scrollen kleiner wird, ändert sich dieser Wert automatisch
      // "mainHeaderHeight - 3" ist der Fix für die kleine Lücke
      const navTopPosition = mainHeaderHeight - 3; 
      nav.style.top = `${navTopPosition}px`;
      
      // Gesamthöhe für den ScrollSpy-Offset berechnen
      const navHeight = nav.offsetHeight;
      const totalStickyHeight = mainHeaderHeight + navHeight;

      if (debugOutput) {
        debugOutput.innerHTML = `Header: ${mainHeaderHeight}px | Top: ${navTopPosition}px`;
      }

      // Nur wenn sich die Höhe signifikant ändert (>2px), bauen wir den Observer neu
      // Das verhindert den Loop, der Firefox crasht.
      if (Math.abs(totalStickyHeight - lastKnownTotalHeight) > 2) {
        lastKnownTotalHeight = totalStickyHeight;
        root.style.scrollPaddingTop = `${totalStickyHeight}px`;

        // Alten Content-Observer trennen
        if (window['_sbContentObserver']) window['_sbContentObserver'].disconnect();

        const observerOptions = {
          root: null, 
          rootMargin: `-${Math.ceil(totalStickyHeight)}px 0px -60% 0px`, 
          threshold: 0.01
        };

        const observerCallback = (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const id = entry.target.id;
              const link = nav.querySelector(`a[href="#${id}"]`);
              
              links.forEach(l => l.classList.remove('sb-is-active'));
              if (link) link.classList.add('sb-is-active');
            }
          });
        };

        window['_sbContentObserver'] = new IntersectionObserver(observerCallback, observerOptions);
        sections.forEach(section => window['_sbContentObserver'].observe(section));
      }
    };
    
    // --- HIER IST DER FIX ---
    // Statt requestAnimationFrame (60x/Sekunde) nutzen wir setInterval (4x/Sekunde)
    // UND einen Scroll-Listener.
    
    // A) Interval: Prüft regelmäßig auf Änderungen (falls sich Header ohne Scrollen ändert)
    window['_sbInterval'] = setInterval(updatePositions, 1000);

    // B) Scroll Listener: Prüft SOFORT wenn gescrollt wird (damit die Nav nicht "wackelt")
    window.addEventListener('scroll', updatePositions, { passive: true });

    // Initiale Ausführung
    updatePositions();

    // Click Handler
    nav.addEventListener('click', (event) => {
      const clickedLink = event.target.closest('.sb-scroll-link');
      if (!clickedLink) return;
      event.preventDefault();
      const targetId = clickedLink.getAttribute('href');
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        // Wir nutzen hier scrollTo mit Offset-Berechnung für maximale Präzision
        const headerH = mainHeader.offsetHeight;
        const navH = nav.offsetHeight;
        const top = targetSection.getBoundingClientRect().top + window.pageYOffset - (headerH + navH);
        
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    });
  };

  // --- INIT FUNCTION ---
  const runScripts = () => {
    if (window.innerWidth <= MOBILE_BREAKPOINT) {
      initStoryblokAccordion();
      document.body.classList.remove('scrollspy-is-active');
      // Interval auf Mobile stoppen um Batterie/CPU zu sparen
      if (window['_sbInterval']) clearInterval(window['_sbInterval']);
    } else {
      initStoryblokScrollspy();
    }
  };

  // Init
  if (document.readyState === 'complete') {
      runScripts();
  } else {
      document.addEventListener('DOMContentLoaded', runScripts);
      document.addEventListener('shopify:section:load', runScripts);
  }

  // Resize Handler (Switch Mobile/Desktop)
  window.addEventListener('resize', () => {
      runScripts();
  });

})();



 document.addEventListener('DOMContentLoaded', function() {
    
    // --- Funktion für interne Mediengalerie-Tabs ---
    function initMediaGalleryTabs() {
      const galleries = document.querySelectorAll('.sb-media-galerie-wrapper');
      
      galleries.forEach(gallery => {
        const navItems = gallery.querySelectorAll('.sb-media-galerie-nav-item');
        const contentItems = gallery.querySelectorAll('.sb-media-galerie-content-item');

        navItems.forEach(item => {
          item.addEventListener('click', function(e) {
            // MOBIL-VERHALTEN: Unter 768px ist es ein normaler Link, der direkt das PDF öffnet
            if (window.innerWidth <= 768) {
              return; 
            }

            // DESKTOP-VERHALTEN: Standard-Link blockieren und Tab öffnen
            e.preventDefault();
            const targetId = this.getAttribute('data-target');

            // Reset
            navItems.forEach(nav => nav.classList.remove('active'));
            contentItems.forEach(content => content.classList.remove('active'));

            // Aktivieren
            this.classList.add('active');
            const targetContent = gallery.querySelector('#' + targetId);
            if (targetContent) {
              targetContent.classList.add('active');
            }
          });
        });
      });
    }

    // --- Funktion für interne Normen-Tabs ---
    function initNormTabs() {
      const normsSections = document.querySelectorAll('.sb-norms-wrapper');
      
      normsSections.forEach(normsSection => {
        const navItems = normsSection.querySelectorAll('.sb-norms-nav-item');
        const contentItems = normsSection.querySelectorAll('.sb-norms-content-item');

        navItems.forEach(item => {
          item.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('data-target');

            // Reset
            navItems.forEach(nav => nav.classList.remove('active'));
            contentItems.forEach(content => content.classList.remove('active'));

            // Aktivieren
            this.classList.add('active');
            const targetContent = normsSection.querySelector('#' + targetId);
            if (targetContent) {
              targetContent.classList.add('active');
            }
          });
        });
      });
    }

    // Init
    initMediaGalleryTabs();
    initNormTabs();
  });